import axios from "axios";

const cep = axios.create({
  method: "GET",
  baseURL: "https://viacep.com.br/ws/",
});

export default cep;
